import { useRouter } from 'next/router';

import { LinkField } from '@sitecore-jss/sitecore-jss-nextjs';

export function useRegisterReturnUrl(linkField: LinkField) {
	const router = useRouter();

	if (!linkField.value?.href?.match(/.*join-the-rcn\/register$/i)) {
		return linkField;
	}

	linkField.value.href =
		linkField.value?.href.split('?')[0] + `?dest=${encodeURIComponent(process.env.PUBLIC_URL + router.asPath)}&amp;sourceSite=rcn-learn`;

	return linkField;
}
